import styles from "./accountsLoader.module.scss";

export const AccountsLoader = () => {
  return <span className={styles.loader}></span>;
};
